module.exports = __webpack_public_path__ + "img/pc_phone.920395c2.png";